module.exports = __webpack_public_path__ + "img/location-menu.d94fd9ec.svg";